export const PRODUCT_REQUEST = "PRODUCT_REQUEST"
export const PRODUCT_FAILURE = "PRODUCT_FAILURE"

//POST
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS"

//GET

export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS"

//PATCH

export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS"

//DELETE
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"